import React, { useContext } from "react";
//import PropTypes from 'prop-types';
import MediaSet from "./MediaSet";
import { useActions, useData, useField } from "state/hooks";
import { openMediaSelect } from "state/actions/media";
import { createCallback } from "state/actions/create";
import uuid from "uuid/v4";
import EntityContext from "containers/context/EntityContext";
import { change } from "state/actions/data";

export function MediaSetContainer(props) {
    const { type, id } = props;
    //const { media } = useData(props);
    const { value, onChange } = useField(type, id, "media_set");

    const { onOpenLibrary, onCreate, onChangeEntity } = useActions({
        onOpenLibrary: openMediaSelect,
        onCreate: createCallback,
        onChangeEntity: change,
    });

    const root = useContext(EntityContext);
    const [rootType, rootId] = root.split("/");

    const create = () => {
        const itemId = uuid();
        onCreate(() => null, "cms.media-set-item", { id: itemId });
        onChange(value ? [...value, itemId] : [itemId]);
        onChangeEntity(rootType, rootId, {});
    };

    const remove = (id) => {
        const newValue = value.filter((item) => item !== id);
        onChange(newValue);
        onChangeEntity(rootType, rootId, {});
    };
    const onChangeItem = (id, value) => {
        onChangeEntity("cms.media-set-item", id, value);
        onChangeEntity(rootType, rootId, {});
    };

    return (
        <MediaSet
            {...props}
            items={value}
            onOpenLibrary={onOpenLibrary}
            onChangeItem={onChangeItem}
            onCreate={create}
            onRemove={remove}
        />
    );
}

MediaSetContainer.propTypes = {};

MediaSetContainer.defaultProps = {
    type: "cms.media",
};

export default MediaSetContainer;
